import React from 'react'
import { select, withKnobs } from '@storybook/addon-knobs'
import { Label } from '.'
import { ColorVariants } from '../../style/themeFields'

export const label = () => (
  <Label
    // @ts-ignore
    variant={select(
      'Variants',
      {
        none: '',
        [ColorVariants.Primary]: ColorVariants.Primary,
        [ColorVariants.Danger]: ColorVariants.Danger,
        [ColorVariants.Success]: ColorVariants.Success,
      },
      '',
    )}
  >
    Label
  </Label>
)

export default {
  component: Label,
  title: 'Label',
  decorators: [withKnobs],
}
